import { useIntl } from 'react-intl';

import { RecommendationType } from '@xing-com/crate-common-graphql-types';
import SearchAndSwipe, {
  type Config,
} from '@xing-com/crate-dream-machine-search-and-shuffle';
import { useLoginAppUrl } from '@xing-com/crate-xinglet';

import { SearchAndSwipeContainer } from './container.style';
import { useSearchAndSwipeData } from './use-search-and-swipe-data';
import { useYourJobsData } from './use-your-jobs-data';

export const Container: React.FC = () => {
  const intl = useIntl();
  const loginAppUrl = useLoginAppUrl();
  const signupChannel = 'minireg_losp_dreammachine';

  const page = 'jobs/index';
  const config: Config = {
    filter: {
      selectLabel: 'Select a card type',
      options: [
        {
          label: intl.formatMessage({
            id: 'SEARCH_AND_SWIPE_ALL_JOBS',
            defaultMessage: 'SEARCH_AND_SWIPE_ALL_JOBS',
          }),
          value: RecommendationType.All,
        },
        {
          label: intl.formatMessage({
            id: 'SEARCH_AND_SWIPE_AVAILABLE_JOBS_ONLY',
            defaultMessage: 'SEARCH_AND_SWIPE_AVAILABLE_JOBS_ONLY',
          }),
          value: RecommendationType.Available,
        },
        {
          label: intl.formatMessage({
            id: 'SEARCH_AND_SWIPE_TAKEN_JOBS_ONLY',
            defaultMessage: 'SEARCH_AND_SWIPE_TAKEN_JOBS_ONLY',
          }),
          value: RecommendationType.Taken,
        },
      ],
    },
    savedCards: {
      url: '/jobs/my-jobs',
      titleKey: 'SEARCH_AND_SHUFFLE_YOUR_JOBS_TITLE',
    },
    interrupterCards: {
      loginUrl: `${loginAppUrl}?signup_channel=${signupChannel}`,
      registrationUrl: `/start/signup?registration=1&signup_channel=${signupChannel}`,
    },
    tracking: {
      trackInView: () => ({
        type: 'nwt',
        event: 'entered_viewport',
        eventSchema: 'basic',
        sentBy: 'jobs',
        page,
        element: 'job_reco_card',
        elementDetail: 'dream_job_reco',
      }),

      trackClickOnFilter: () => ({
        type: 'nwt',
        event: 'clicked',
        eventSchema: 'basic',
        sentBy: 'jobs',
        page,
        element: 'job_reco_filter_open',
      }),
      trackFilterSelection: (filter: string) => {
        const trackingfilter =
          filter === RecommendationType.Available
            ? 'more_available'
            : filter === RecommendationType.Taken
              ? 'more_occupied'
              : 'available_occupied';

        return {
          type: 'nwt',
          event: 'clicked',
          eventSchema: 'basic',
          sentBy: 'jobs',
          page,
          element: `job_reco_filter_${trackingfilter}_apply`,
        };
      },
    },
  };

  return (
    <SearchAndSwipeContainer>
      <SearchAndSwipe
        useData={useSearchAndSwipeData}
        useSavedData={useYourJobsData}
        config={config}
        hideSavedCards
        hideAds
      />
    </SearchAndSwipeContainer>
  );
};
